import { render, staticRenderFns } from "./PazienteTeleconsultoHasssito.vue?vue&type=template&id=e21feeb0&scoped=true"
import script from "./PazienteTeleconsultoHasssito.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultoHasssito.vue?vue&type=script&lang=js"
import style0 from "./PazienteTeleconsultoHasssito.vue?vue&type=style&index=0&id=e21feeb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21feeb0",
  null
  
)

export default component.exports